const firebaseConfig = {
    apiKey: "AIzaSyBSseOiR8YZwmSUxlQg5Hg6lDd2ys52KrQ",
    authDomain: "travel-guru-3fa34.firebaseapp.com",
    databaseURL: "https://travel-guru-3fa34.firebaseio.com",
    projectId: "travel-guru-3fa34",
    storageBucket: "travel-guru-3fa34.appspot.com",
    messagingSenderId: "56568502501",
    appId: "1:56568502501:web:089f53987eb292d70d9c0c"
  };
  export default firebaseConfig;